import type { RouteObject } from 'react-router-dom';

/** Views 32 (subscriptions), 33 (deliveries and DLQ) and 34 (event log). */
export const webhooksRoutes: RouteObject[] = [
  {
    path: 'webhooks',
    lazy: () =>
      import('../pages/WebhooksPage').then((m) => ({
        Component: m.WebhooksPage,
      })),
  },
  {
    path: 'webhooks/deliveries',
    lazy: () =>
      import('../pages/DeliveriesPage').then((m) => ({
        Component: m.DeliveriesPage,
      })),
  },
  {
    path: 'events',
    lazy: () =>
      import('../pages/EventsLogPage').then((m) => ({
        Component: m.EventsLogPage,
      })),
  },
];
